module.exports = __webpack_public_path__ + "static/media/icon_qitalianxi_pc.8f1636cd.svg";